import styled from 'styled-components';

export const ButtonWrapper = styled.div`
margin: 50px 0
`;